import { motion } from 'framer-motion';
import { Card as CardType, Suit } from '../shared/types';

const SUIT_SYMBOL: Record<Suit, string> = { h: '♥', d: '♦', c: '♣', s: '♠' };
const SUIT_COLOR: Record<Suit, string> = {
  h: 'text-rose-500',
  d: 'text-rose-500',
  c: 'text-ink-900',
  s: 'text-ink-900',
};

interface CardProps {
  card: CardType | null; // null = карта ещё не роздана (пусто)
  faceDown?: boolean; // true = рубашкой вверх (чужая карта в игре)
  size?: 'sm' | 'md' | 'lg';
  delay?: number;
  highlight?: boolean; // подсветка карт, вошедших в выигрышную комбинацию
}

const SIZE_MAP = {
  sm: 'w-8 h-11 text-[10px]',
  md: 'w-11 h-16 text-sm',
  lg: 'w-16 h-24 text-xl',
};

export function PlayingCard({ card, faceDown, size = 'md', delay = 0, highlight = false }: CardProps) {
  const dims = SIZE_MAP[size];

  if (!card && !faceDown) {
    return <div className={`${dims} rounded-md border border-dashed border-white/10`} />;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -30, scale: 0.6, rotate: -12 }}
      animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }}
      transition={{ delay, duration: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
      className={`${dims} card-3d relative rounded-md shadow-card ${
        highlight ? 'ring-2 ring-emerald-400 shadow-goldGlow' : ''
      }`}
    >
      {faceDown || !card ? (
        <div
          className="w-full h-full rounded-md border border-gold-500/40 flex items-center justify-center bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(6,36,22,0.75), rgba(4,20,13,0.9)), url(/textures/velvet.jpg)`,
          }}
        >
          <div
            className="w-1/2 h-1/2 rounded-sm border border-gold-400/60 bg-cover bg-center opacity-70"
            style={{ backgroundImage: `url(/textures/gold-foil.jpg)` }}
          />
        </div>
      ) : (
        <div className="w-full h-full rounded-md bg-[#faf6ea] border border-black/10 flex flex-col p-1 select-none relative overflow-hidden">
          <div className={`flex flex-col items-center leading-none ${SUIT_COLOR[card.suit]}`}>
            <span className="font-bold">{card.rank}</span>
            <span className="text-[0.8em] -mt-0.5">{SUIT_SYMBOL[card.suit]}</span>
          </div>
          {/* Крупный полупрозрачный символ масти по центру — премиальный вид без "битых" перевёрнутых цифр */}
          <span
            className={`absolute inset-0 flex items-center justify-center text-3xl opacity-15 ${SUIT_COLOR[card.suit]}`}
          >
            {SUIT_SYMBOL[card.suit]}
          </span>
        </div>
      )}
    </motion.div>
  );
}
